import { WidgetInitializer } from "../functions/widget-initializer";
import { ConfigUtils } from "../functions/config-utils";
import { Constants } from "../functions/constants";
import { GoogleUtils } from "../functions/google-utils";
import { LocalStorageUtils } from "../functions/local-storage-utils";
import { BranchUtils } from "../functions/branch-utils";
import { ArrayUtils } from "../functions/array-utils";

import '../filters/to-miles';

var widgetInitializer = new WidgetInitializer(Constants.COMPONENTS.BRANCH_FINDER);
GlobalApp.registerInitializationHandler(Constants.COMPONENTS.BRANCH_FINDER, function () {
    widgetInitializer.initialize(initBranchFinderApp);
});

function initBranchFinderApp(element) {
    var config = ConfigUtils.getConfigFor(element);
    var vueApp = new Vue({
        el: '#' + element.id,
        data: {
            initializationReadyHook: GlobalApp.getInitializationReadyHook(),
            type_filters: config.equipmentTypes,
            locations_data: [],
            filters_open: false,
            has_preselection: false,
            searchTerm: '',
            map: null,
            markers: [],
            myStoreId: null,
            search_request: {
                "equipmentTypes": [],
                "pageNumber": "1",
                "pageSize": "20",
                "searchRadius": Constants.LOCAL_STORAGE.DEFAULT_RADIUS
            },
            mapCenter: {
                latitude: 0,
                longitude: 0
            },
            radius_options: config.radiusOptions
        },
        watch: {
            mapLoaded: {
                immediate: true,
                handler(newVal, oldVal) {
                    if (newVal)
                        this.init();
                }
            },
            search_request: {
                immediate: true,
                deep: true,
                handler(newVal, oldVal) {
                    {
                        if (newVal && newVal.equipmentTypes) {
                            this.has_preselection = newVal.equipmentTypes.length !== 0
                        }
                    }
                }
            },
        },

        computed: {
            mapLoaded() {
                return window.mapLoaded;
            }
        },

        methods: {
            init: async function init() {
                await this.initSearchFilters();

                this.initGoogleMaps();

                try {
                    await this.search(false);
                } catch (e) {
                    GlobalApp.ErrorHandler.autoHandle(e);
                }

                // If the only branch in the list of results is the Online branch - recenter the map
                if (this.locations_data.length <= 1) {
                    this.centerMap();
                }

                this.initializationReadyHook(element.id);
            },
            initSearchFilters: async function () {
                var queryLocationFilters = await BranchUtils.getQueryLocationFilters();

                this.mapCenter = queryLocationFilters.searchFilters;
                var deviceLocationFilters = queryLocationFilters.distanceFilters;

                this.search_request = { ...this.search_request, ...this.mapCenter, ...deviceLocationFilters };

                if (this.search_request?.equipmentTypes?.length > 0) {
                    this.filters_open = true;
                    this.has_preselection = true;
                }
            },
            initGoogleMaps: function () {
                this.map = new window.google.maps.Map(this.$refs["map"], {
                    zoom: Constants.LOCATIONS_GOOGLE_MAP.ZOOM,
                    maxZoom: Constants.LOCATIONS_GOOGLE_MAP.MAX_ZOOM
                });
            },
            search: function (scrollToResults) {
                var $this = this;
                this.persistSearchParameters();

                if (!this.searchTerm)
                    return $this.executeBranchSearch();

                var geocodeUrl = GoogleUtils.getGeocodeRequestUrl(GlobalApp.generalSettings.googleMapApiV3Key, this.searchTerm);
                return GlobalApp.FetchClient.fetchJson(geocodeUrl, {
                    method: 'GET',
                    skipHeaders: ['Accept', 'Content-Type', 'Cache-Control']
                }).then(locationData => {
                    var locationDetails = GoogleUtils.extractGeocodeLocationDetails(locationData);
                    if (locationDetails) {
                        $this.search_request.Latitude = locationDetails.latitude;
                        $this.search_request.Longitude = locationDetails.longitude;
                    } else {
                        return $this.getOnlineBranch();
                    }
                    if (window.isMobile && typeof scrollToResults === 'object') {
                        window.scroll({
                            top: 630, 
                            left: 0, 
                            behavior: 'smooth'
                        });
                    }
                    
                    return $this.executeBranchSearch();
                })
            },
            async getOnlineBranch() {
                var onlineBranch = await GlobalApp.BranchService.getOnlineBranch();
                if (onlineBranch && onlineBranch.BranchName)
                    this.locations_data = [onlineBranch];
            },
            async executeBranchSearch() {
                let branchesData = await GlobalApp.BranchService.query(this.search_request);
                this.locations_data = branchesData?.Items || [];
                if (ArrayUtils.isNotEmpty(this.locations_data) === false) {
                    await this.getOnlineBranch();
                }

                this.removeOldMarkers();
                this.setMarkers();
                this.drawMarkers();
            },
            toggleFilters: function toggleFilters() {
                this.filters_open = !this.filters_open;
            },
            getButtonText: function getButtonText(mystore) {
                return mystore ? 'My Store' : 'Make My Store';
            },
            setMyStore: function setMyStore(item) {
                this.myStoreId = item.Id;
                GlobalApp.MyStoreService.updateMyStorePreferencesAndNotify(this, item);
            },
            myStoreUpdateEventHandler: function (object, branchDetails) {
                if (object === this)
                    return;

                if (!branchDetails)
                    return;

                this.myStoreId = branchDetails.Id;
            },
            setMarkers: function setMarkers() {
                this.markers = [];

                var _icon = {
                    url: "/ResourcePackages/Main/assets/static_assets/location-pin-green.svg",
                    scaledSize: new google.maps.Size(33, 38)
                    // origin: new google.maps.Point(0, 0),
                    // anchor: new google.maps.Point(0, 0)
                };

                this.locations_data.map(el => {
                    var $this = this;
                    var marker = new window.google.maps.Marker({
                        position: { lat: el.Address.Latitude, lng: el.Address.Longitude },
                        map: null,
                        displayed: true,
                        icon: _icon,
                        name: el.BranchName,
                        equipmentTypes: el.equipmentTypes,
                        infowindow: $this.getInfoWindow(el)
                    });
                    this.markers.push(marker);

                    var $map = $this.map;
                    google.maps.event.addListener(marker, 'click', function () {                        
                        if (window.current_info_window) {
                            window.current_info_window.close()
                        }
                        marker.infowindow.open({
                            anchor: this,
                            $map
                        });
                        window.current_info_window = marker.infowindow;
                    });
                });
            },
            getInfoWindow: function getInfoWindow(location) {
                var address_string = `${location.Address.Street}<br/>${location.Address.City}, ${location.Address.StateCode} ${location.Address.Zip}`;
                var phones = JSON.parse(location.PhoneNumbers);
                var phone_string = '';
                phones.map(el => {
                    if (el.isVisible) {
                        var phone_line = `<a href="tel:${el.value}" class="iw_phone">${el.name}: ${el.value}</a>`
                        phone_string += phone_line;
                    }
                });
                var contentString = `<div class="infowindow">
                <p class="iw_title">${location.BranchName}</p>
                <p class="iw_address">${address_string}</p>
                <p>${phone_string}</p>
                <a class="styled_button iw_link" href="${location.Url}">Details</a>
                </div>`;

                var infowindow = new google.maps.InfoWindow({
                    content: contentString,
                });

                return infowindow;
            },
            drawMarkers: function drawMarkers() {
                if (!this.map)
                    return;

                if (ArrayUtils.isNotEmpty(this.markers) === false) {
                    var circle = new google.maps.Circle({
                        strokeOpacity: 0,
                        strokeWeight: 0,
                        fillOpacity: 0,
                        map: this.map,
                        center: new google.maps.LatLng(parseFloat(this.search_request.Latitude), parseFloat(this.search_request.Longitude)),
                        radius: parseInt(this.search_request.searchRadius, 10) * 1609
                    });
                    this.map.fitBounds(circle.getBounds());
                    return;
                }

                var bounds = new google.maps.LatLngBounds();
                this.markers.map(el => {
                    el.setMap(this.map);
                    bounds.extend(el.position);
                });
                this.map.fitBounds(bounds);
            },
            removeOldMarkers() {
                this.markers.forEach(marker => {
                    if (marker && typeof marker.setMap === 'function') {
                        marker.setMap(null);
                    }
                });
            },
            centerMap: function getAddressString() {
                if (!this.map)
                    return;

                this.map.setCenter(new google.maps.LatLng(parseFloat(this.mapCenter.Latitude), parseFloat(this.mapCenter.Longitude)));
            },
            getAddressString: function getAddressString(location) {
                return BranchUtils.getAddressString(location);
            },
            isMyStore: function isMyStore(location) {
                return this.myStoreId === location.Id;
            },
            mapMyStore: function (myStoreId) {
                if (this.myStoreId === null)
                    this.myStoreId = myStoreId;
            },
            mapSearchParameters: function () {
                var stored_data = LocalStorageUtils.getLocalStorageData();
                this.search_request.searchRadius = stored_data.searchRadius;
                this.search_request.equipmentTypes = stored_data.equipmentTypes;
                this.searchTerm = stored_data.searchTerm;
            },
            persistSearchParameters: function () {
                LocalStorageUtils.updateLocalStorageData(otherPreferences => {
                    otherPreferences.searchRadius = this.search_request.searchRadius;
                    otherPreferences.searchTerm = this.searchTerm;
                    otherPreferences.equipmentTypes = this.search_request.equipmentTypes;
                });
            }
        },

        created: function () {
            GlobalApp.MyStoreService.getMyStoreId().then(this.mapMyStore);

            this.mapSearchParameters();

            GlobalApp.EventHub.subscribeToEvent(Constants.EVENTS.CART.MY_STORE_UPDATE, this.myStoreUpdateEventHandler);
        },

        destroyed() {
            GlobalApp.EventHub.unsubscribeToEvent(Constants.EVENTS.CART.MY_STORE_UPDATE, this.myStoreUpdateEventHandler);
        }
    });

    return vueApp.$el;
}